<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AvR4ep/tc-custom/9780544376960.jpg?1736946041739" alt="This image is the cover for the book Healthy Happy Vegan Kitchen"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Healthy Happy Vegan Kitchen
      </h1>
      <p class="bookDescription body article font2">
        <b>Over 220 recipes so delicious it’s hard to believe they’re actually vegan: “Brilliant and creative…So many things I want to make!”–Gina Homolka, #1 <i>New York Times</i>-bestselling author of <i>The Skinnytaste Cookbook</i></b><br/>  <br/> A diet free of animal products is a healthy choice, and it also means living a greener life and changing the world for the better—one plate at a time. Kathy Patalsky, creator of the popular vegan food blog Healthy.Happy.Life, read by millions, makes sure eating vegan is fun and delicious too. In <i>Healthy Happy Vegan Kitchen</i>, you’ll find flavor-packed recipes for Vegan Philly Cheese Sandwich, Ultra Creamy Cashew Veggie Pot Pie, Garden Veggie Frittata, and over two hundred more.<br/>  <br/> Along with the inventive recipes, the book also includes guides to help “veganize” your kitchen with helpful ingredient and equipment information, cooking techniques for vegan staples, nutrition information, and wellness tips—making it the perfect book for both long-time vegans and newcomers alike.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kathy Patalsky
      </h2>
      
      <p class="authorDescription body article">KATHY PATALSKY is the creator of the popular vegan food blog HealthyHappyLife.com and is the author of 365 Vegan Smoothies. Her work has been featured in Saveur, BuzzFeed, LATimes, Fox, and CNN, on the cover of VegNews, and more.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?444b111e